import { Typography, useTheme } from '@mui/material';

import { Card } from 'src/components';
import { Flex } from 'src/components/Flex';

import DisplayText from './DisplayText';

interface BillingDetailsProps {
    name: string;
    billingAddress: string | string[];
    contactNumber: string;
    email: string;
}

function BillingDetails({ billingAddress, contactNumber, email, name }: BillingDetailsProps) {
    const theme = useTheme();
    return (
        <Card color={theme.palette.text.primary} flex={1} gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Billing Details
            </Typography>
            <Flex>
                <Flex flexDirection="column" flex={1} gap="30px">
                    <DisplayText label="Billing Contact" value={name} />
                    <DisplayText label="Contact Number" value={contactNumber} />
                    <DisplayText label="Email" value={email} />
                </Flex>
                <Flex flex={1}>
                    <DisplayText label="Billing Address" value={billingAddress} />
                </Flex>
            </Flex>
        </Card>
    );
}

export default BillingDetails;
